import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getQuestionsByIds } from "../../api/eventService";
import { ADMIN_URL } from "../../utils/constants";

const defaultPollInfo = {
  polls: {},
};

export const changePollsState = createAsyncThunk(
  "eventInfo/changePollsState",
  async ({ poll }, storeAPI) => {
    if (poll.questions && !poll.isOver && ADMIN_URL) {
      const response = await getQuestionsByIds(poll.questions);
      return {
        id: poll._id,
        title: poll.title,
        questions: response,
        isRunning: !poll.isOver,
      };
    } else {
      return poll;
    }
  },
);

export const fetchPollDataApi = createAsyncThunk(
  "eventInfo/fetchPollDataApi",
  async (_, storeAPI) => {
    if (!ADMIN_URL) {
      return {};
    }

    const polls = (
      await axios.get(`${ADMIN_URL}/poll/running/poll`, {
        params: { full: true },
      })
    ).data;
    const stateObject = polls.reduce((acc, item) => {
      acc[item._id] = { ...item, isRunning: true };
      return acc;
    }, {});
    return stateObject;
  },
);

export const pollInfoSlice = createSlice({
  name: "eventInfo",
  initialState: defaultPollInfo,
  reducers: {
    clearEventState: (state, action) => {
      state.polls = action.payload?.polls || {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPollDataApi.fulfilled, (state, action) => {
        state.polls = action.payload;
      })
      .addCase(changePollsState.fulfilled, (state, action) => {
        if (action.payload.isOver) {
          delete state.polls[action.payload._id];
        } else {
          state.polls[action.payload.id] = action.payload;
        }
      });
  },
});

export const { clearEventState } = pollInfoSlice.actions;
export default pollInfoSlice.reducer;
